<template>
    <div>
        <div @mousemove="move" class="w3l-banner">
            <div :style="
                'transform: translate(' +
                (position == 'left' ? '20' : '-20') +
                'px,' +
                (position2 == 'top' ? '10' : '-10') +
                'px) scale(1.1)'
            " class="banner-image"></div>
            <div class="titleBox">
                <div class="wow flipInX titleT1" :class="contType == 'e' ? 'titleT1e' : ''">{{ contList[contType][0] }}
                </div>
                <div class="wow flipInX titleT2" :class="contType == 'e' ? 'titleT2e' : ''">{{ contList[contType][1] }}
                </div>
                <img class="wow bounceInRight titlebgIcon1" src="../assets/img/Collection/icon.png" alt="" />
                <img class="wow bounceInUp titlebg" src="../assets/img/Collection/person.png" alt="" />
            </div>
        </div>

        <div class="contBox">
            <div class="itemBox">
                <div class="wow bounceInUp " :class="curIndex == 0 ? 'item_s' : 'item'" @click="clickChangePage(1)">
                    <img v-if="curIndex == 0" :class="contType == 'e' ? 'icone' : 'icon'"
                        src="../assets/img/Collection/1008_s.png" alt="">
                    <img v-if="curIndex != 0" :class="contType == 'e' ? 'icone' : 'icon'"
                        src="../assets/img/Collection/1008.png" alt="">
                    <div class="textBox">
                        <div :class="curIndex == 0 ? 'text22_s' : 'text22'">{{ contList[contType][2] }}</div>
                        <div :class="[curIndex == 0 ? 'text14_s' : 'text14', curIndex == 0 ? 'text14_se' : 'text14_e']">
                            {{ contList[contType][3] }}</div>
                    </div>
                </div>
                <div class="wow bounceInUp " :class="curIndex == 1 ? 'item_s' : 'item'" data-wow-delay="0.5s"
                    @click="clickChangePage(2)">
                    <img v-if="curIndex == 1" :class="contType == 'e' ? 'icone' : 'icon'"
                        src="../assets/img/Collection/1228_s.png" alt="">
                    <img v-if="curIndex != 1" :class="contType == 'e' ? 'icone' : 'icon'"
                        src="../assets/img/Collection/1228.png" alt="">
                    <div class="textBox">
                        <div :class="curIndex == 1 ? 'text22_s' : 'text22'">{{ contList[contType][4] }}</div>
                        <div :class="[curIndex == 1 ? 'text14_s' : 'text14', curIndex == 1 ? 'text14_se' : 'text14_e']">
                            {{ contList[contType][5] }}</div>
                    </div>
                </div>
                <div class="wow bounceInUp " :class="curIndex == 2 ? 'item_s' : 'item'" data-wow-delay="1s"
                    @click="clickChangePage(3)">
                    <img v-if="curIndex == 2" :class="contType == 'e' ? 'icone' : 'icon'"
                        src="../assets/img/Collection/1004_s.png" alt="">
                    <img v-if="curIndex != 2" :class="contType == 'e' ? 'icone' : 'icon'"
                        src="../assets/img/Collection/1004.png" alt="">
                    <div class="textBox">
                        <div :class="curIndex == 2 ? 'text22_s' : 'text22'">{{ contList[contType][6] }}</div>
                        <div :class="[curIndex == 2 ? 'text14_s' : 'text14', curIndex == 2 ? 'text14_se' : 'text14_e']">
                            {{ contList[contType][7] }}</div>
                    </div>
                </div>
            </div>

            <el-carousel ref="page" class="wow bounceInUp " style="width:636px" height="763px" :interval="5000"
                direction="vertical" @change="pageChange" data-wow-delay="0.25s" arrow="never">
                <el-carousel-item v-for="item in 3" :key="item" :name="item + ''">
                    <div v-if="item === 1" class="crdBox">
                        <img class="img1" src="../assets/img/Collection/Maps.png" alt="">
                        <img class="img2" src="../assets/img/Collection/Free Chart Image on Unsplash.png" alt="">
                        <img class="img3" :src="imagesPC[contType][0]" alt="">
                    </div>
                    <div v-if="item === 2" class="crdBox">
                        <img class="img11" src="../assets/img/Collection/Maps.png" alt="">
                        <img class="img21"
                            src="../assets/img/Collection/brown leather bifold wallet on gray concrete floor.png"
                            alt="">
                        <img class="img31" :src="imagesPC[contType][0]" alt="">
                    </div>
                    <div v-if="item === 3" class="crdBox">
                        <img class="img11" src="../assets/img/Collection/Maps.png" alt="">
                        <img class="img21" src="../assets/img/Collection/Free Computer Image on Unsplash.png" alt="">
                        <img class="img31" :src="imagesPC[contType][0]" alt="">
                    </div>
                </el-carousel-item>
            </el-carousel>

        </div>

        <div class="contBox1">
            <Swiper :options="swiperOption" ref="mySwiper" class="sw" @ready="onSwiper" @slideChange="onSlideChange">
                <Swiper-Slide style="width: 100%;">
                    <div class="itemBox_p">
                        <img class="icon" src="../assets/img/Collection/1008.png" alt="">
                        <div class="text22">{{ contList[contType][2] }}</div>
                        <div class="text14">{{ contList[contType][3] }}</div>
                        <div class="itemImageBox_p">
                            <img class="img1" src="../assets/img/Collection/Maps.png" alt="">
                            <img class="img2" :src="images[contType][1]" alt="">
                            <img class="img3" :src="images[contType][0]" alt="">
                        </div>
                    </div>
                </Swiper-Slide>

                <Swiper-Slide style="width: 100%;">
                    <div class="itemBox_p">
                        <img class="icon" src="../assets/img/Collection/1228.png" alt="">
                        <div class="text22">{{ contList[contType][4] }}</div>
                        <div class="text14">{{ contList[contType][5] }}</div>
                        <div class="itemImageBox_p">
                            <img class="img1" src="../assets/img/Collection/Maps.png" alt="">
                            <img class="img2" :src="images[contType][3]" alt="">
                            <img class="img3" :src="images[contType][2]" alt="">
                        </div>
                    </div>
                </Swiper-Slide>

                <Swiper-Slide style="width: 100%;">
                    <div class="itemBox_p">
                        <img class="icon" src="../assets/img/Collection/1004.png" alt="">
                        <div class="text22">{{ contList[contType][6] }}</div>
                        <div class="text14">{{ contList[contType][7] }}</div>
                        <div class="itemImageBox_p">
                            <img class="img1" src="../assets/img/Collection/Maps.png" alt="">
                            <img class="img2" :src="images[contType][5]" alt="">
                            <img class="img3" :src="images[contType][4]" alt="">
                        </div>
                    </div>
                </Swiper-Slide>
            </Swiper>
            <div class="wow bounceInUp pagination">
                <div class="point" :class="[phoneIndex == 0 ? 'point_s' : '']" @click="clickChangePage1(0)"></div>
                <div class="point mgLR" :class="[phoneIndex == 1 ? 'point_s' : '']" @click="clickChangePage1(1)"></div>
                <div class="point" :class="[phoneIndex == 2 ? 'point_s' : '']" @click="clickChangePage1(2)"></div>
            </div>
        </div>

    </div>
</template>
<script>


import { WOW } from "wowjs";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { Autoplay } from 'swiper'

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    name: "index",
    data: (vm) => {
        return {
            bodyW: 0,
            bodyY: 0,
            position: "",
            position2: "",
            contList: {
                z: [
                    "平台收款解决方案",
                    "支持Shopee、Wish、eBay、Lazada等主流跨境电商平台的收款，\n商户用更低的成本，便可将国外货款安全高效地回收。",
                    "费率更优",
                    "免费接入，仅收取单笔提现手续费；根据累计入账额，实行阶梯递减的费率",
                    "极速提现",
                    "及时高效，提升资金周转率；参照中国银行实时汇率，透明无汇损",
                    "灵活管理",
                    "单账户实现多平台店铺的统一管理，省时省心；本地化服务沟通舒心，7*24小时及时响应",
                ],
                f: [
                    "平颱收款解決方案",
                    "支持Shopee、Wish、eBay、Lazada等主流跨境電商平颱的收款，\n商戶用更低的成本，便可將國外貨款安全高效地回收。",
                    "費率更優",
                    "免費接入，僅收取單筆提現手續費；根據累計入賬額，實行階梯遞減的費率",
                    "極速提現",
                    "及時高效，提昇資金週轉率；參照中國銀行實時匯率，透明無匯損",
                    "靈活管理",
                    "單賬戶實現多平颱店鋪的統一管理，省時省心；本地化服務溝通舒心，7*24小時及時響應",
                ],
                e: [
                    'Platform Collection Solutions',
                    "Suntone supports collection of funds on Shopee, Wish, eBay, Lazada and other mainstream cross-border e-commerce platforms, so that merchants can safely and efficiently recover their foreign payments at lower cost.",
                    "Better Rate",
                    "Free access, only charge a single withdrawal fee; According to the accumulated amount, a step-down rate is implemented.",
                    "Instant Withdrawal",
                    "Timely and efficient, improving the capital turnover rate; Referring to the real-time exchange rates of the People's Bank of China, transparent transaction without loss of exchange.",
                    "Flexible Management",
                    "Unified management of multi-platform stores in a single account, saving time and saving trouble; easy communications during localized services, 7*24 hours timely response.",
                ]
            },
            imagesPC: {
                z: [
                    require('../assets/img/Collection/1184z.png'),
                    require('../assets/img/Collection/1183z.png'),
                    require('../assets/img/Collection/1185z.png'),
                ],
                f: [
                    require('../assets/img/Collection/1184f.png'),
                    require('../assets/img/Collection/1183f.png'),
                    require('../assets/img/Collection/1185f.png'),
                ],
                e: [
                    require('../assets/img/Collection/1184.png'),
                    require('../assets/img/Collection/1183.png'),
                    require('../assets/img/Collection/1185.png'),
                ]
            },
            contType: "z",
            curIndex: 0,
            phoneIndex: 0,
            swiperOption: {
                // swiper options 所有的配置同swiper官方api配置
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                },   // 自动播放的时间间隔
                slidesPerView: 1,  //一次显示的数量
                direction: "horizontal", // 水平轮播,
                modules: [Autoplay],
            },
            swiper: null,
            images: {
                z: [
                    require('../assets/img/mobile/z/1184.png'),
                    require('../assets/img/mobile/z/Free Chart Image on Unsplash.png'),

                    require('../assets/img/mobile/z/1617.png'),
                    require('../assets/img/mobile/z/brown leather bifold wallet on gray concrete floor.png'),

                    require('../assets/img/mobile/z/1620.png'),
                    require('../assets/img/mobile/z/Free Computer Image on Unsplash.png'),
                ],
                f: [
                    require('../assets/img/mobile/f/1609.png'),
                    require('../assets/img/mobile/f/Free Chart Image on Unsplash.png'),

                    require('../assets/img/mobile/f/1614.png'),
                    require('../assets/img/mobile/f/brown leather bifold wallet on gray concrete floor.png'),

                    require('../assets/img/mobile/f/1623.png'),
                    require('../assets/img/mobile/f/Free Computer Image on Unsplash.png'),
                ],
                e: [
                    require('../assets/img/mobile/e/1610.png'),
                    require('../assets/img/mobile/e/Free Chart Image on Unsplash.png'),

                    require('../assets/img/mobile/e/1618.png'),
                    require('../assets/img/mobile/e/brown leather bifold wallet on gray concrete floor.png'),

                    require('../assets/img/mobile/e/1624.png'),
                    require('../assets/img/mobile/e/Free Computer Image on Unsplash.png'),
                ]
            }
        };
    },
    methods: {
        move(e) {
            if (e.pageX > this.bodyW / 2) {
                this.position = "right";
            } else {
                this.position = "left";
            }
            if (e.pageY > 250) {
                this.position2 = "top";
            } else {
                this.position2 = "bottom";
            }
        },
        pageChange(index) {
            this.curIndex = index
        },
        clickChangePage(index) {
            this.$refs.page.setActiveItem(index + '')
        },
        clickChangePage1(index) {
            // this.$refs.mySwiper.slideTo(index);
            this.swiper.slideTo(index);
            console.log(this.$refs.mySwiper)
        },
        onSwiper(swiper) {
            this.swiper = swiper
            console.log('哈哈哈哈哈', swiper);
        },
        onSlideChange(swiper) {
            this.swiper = swiper
            this.phoneIndex = swiper.activeIndex
            // console.log('slide change',swiper);
        },
        changeTypeTitleName() {
            if (this.contType == "f") {
                document.title = "平颱收款解決方案";
            } else if (this.contType == 'e') {
                document.title = 'Platform Collection Solutions'
            } else {
                document.title = "平台收款解决方案";
            }
        }
    },

    mounted() {
        this.bodyW = document.body.clientWidth;
        this.bodyY = document.body.clientHeight;
        var that = this;
        this.contType = window.localStorage.getItem('language');
        that.changeTypeTitleName()
        window.addEventListener('setItemEvent', function (e) {
            if (e.key == "language") {
                that.contType = e.newValue;
                that.changeTypeTitleName()
            }
        })
        var wow = new WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 40,
            mobile: true,
            live: true,
        });
        wow.init();


    },
};
</script>


<style src="../assets/css/Collection-pc.css"  scoped>

</style>
<style src="../assets/css/Collection-phone.css"  scoped>

</style>
